import { takeLatest, call, put } from "redux-saga/effects";
import axios from "axios";
import {
  addInstituteSuccess,
  addDroneManufacturerSuccess,
  addDroneManufacturerFailure,
  addInstituteFailure,
  getInstitutesFailure,
  getInstitutesSuccess,
  getSingleInstitutesFailure,
  getSingleInstitutesSuccess,
} from "../slice/instituteSlice";
import { setShowModel } from "../slice/otpSlice";
import { setError } from "../slice/errorSlice";
const url = process.env.REACT_APP_API_URL;
// const url =" http://localhost:6002"

function* addInstituteRequest(action) {
  try {
    const response = yield call(() =>
      axios.post(`${url}/addInstitute`, action.payload.formData)
    );
    if (response.data.status == "success") {
      yield put(setShowModel(true));
      yield put(
        addInstituteSuccess({
          email: action.payload.email,
          phoneNumber: action.payload.phoneNumber,
        })
      );
    } else {
      yield put(addInstituteFailure(response.data.message));
      yield put(setShowModel(false));
      yield put(setError(response.data.message));
    }
  } catch (error) {
    yield put(addInstituteFailure(error.message));
    yield put(setError(error.message));
  }
}
function* addEnlistDroneRequest(action) {
  try {
    const response = yield call(() =>
      axios.post(`${url}/addEnlistDrone`, action.payload.formData)
    );
    if (response.data.status == "success") {
      yield put(setShowModel(true));
      yield put(
        addDroneManufacturerSuccess({
          email: action.payload.email,
          phoneNumber: action.payload.phoneNumber,
        })
      );
    } else {
      yield put(addDroneManufacturerFailure(response.data.message));
      yield put(setShowModel(false));
      yield put(setError(response.data.message));
    }
  } catch (error) {
    yield put(addDroneManufacturerFailure(error.message));
    yield put(setError(error.message));
  }
}

function* getInstitutesRequest(action) {
  try {
    const response = yield call(() =>
      axios.get(
        `${url}/getInstitute?page=${action.payload.page}&limit=1000`
      )
    );
    if (response.data.status == "success") {
      yield put(getInstitutesSuccess(response.data.data));
    } else {
      yield put(getInstitutesFailure(response.data.message));
    }
  } catch (error) {
    yield put(getInstitutesFailure(error.message));
  }
}
function* getSingleInstitutesRequest(action) {
  try {
    const response = yield call(() =>
      axios.get(`${url}/instituteDetails?instituteId=${action.payload}`)
    );

    if (response.data.status == "success") {
      yield put(getSingleInstitutesSuccess(response.data.data));
    } else {
      yield put(getSingleInstitutesFailure(response.data.message));
    }
  } catch (error) {
    yield put(getSingleInstitutesFailure(error.message));
  }
}

export function* watchGetInstitutes() {
  yield takeLatest("institute/getInstitutes", getInstitutesRequest);
}

export function* watchGetSingleInstitutes() {
  yield takeLatest("institute/getSingleInstitutes", getSingleInstitutesRequest);
}

export function* watchAddInstitute() {
  yield takeLatest("institute/addInstitute", addInstituteRequest);
}
export function* watchAddDroneManufacturer() {
  yield takeLatest("institute/addDroneManufacturer", addEnlistDroneRequest);
}
